import { Cart, OrderEntry } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { GetCartEntryProps } from '../../../types';

export const getCartEntry = (
  params: GetCartEntryProps,
  currentCart: Cart
): OrderEntry => currentCart?.entries.find(entry => entry?.product?.code === params.productCode);
